import React from 'react';
import Wrapper from './styles';
import { useFilterContext } from '../../context/filter_context';
import { useLanguageContext } from '../../context/language_context';
import { getUniqueValues, formatPrice } from '../../utils/helpers';
import { FaCheck, FaHome, FaUtensils, FaCouch, FaBed, FaBath, FaArchive } from 'react-icons/fa';

const Filters = () => {
  const { t, isArabic } = useLanguageContext();
  const {
    filters: {
      text,
      ShopName,
      category,
      color,
      min_price,
      max_price,
      price,
      shipping,
    },
    updateFilters,
    clearFilters,
    all_products,
  } = useFilterContext();

  const categories = getUniqueValues(all_products, 'category');
  const companies = getUniqueValues(all_products, 'ShopName');
  const colors = getUniqueValues(all_products, 'colors');

  // Get product count per category
  const getCategoryCount = (cat) => {
    if (cat === 'all') return all_products.length;
    return all_products.filter(p => p.category?.toLowerCase() === cat.toLowerCase()).length;
  };

  // Category icon mapping
  const getCategoryIcon = (cat) => {
    const name = cat.toLowerCase();
    if (name === 'all') return FaHome;
    if (name.includes('kitchen') || name.includes('cuisine')) return FaUtensils;
    if (name.includes('living') || name.includes('salon')) return FaCouch;
    if (name.includes('bedroom') || name.includes('chambre')) return FaBed;
    if (name.includes('bathroom') || name.includes('salle de bain')) return FaBath;
    if (name.includes('storage') || name.includes('rangement')) return FaArchive;
    return FaArchive;
  };

  return (
    <Wrapper style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <div className='content'>
        {/* Header */}
        <div className='filters-header'>
          <h3>{t.products?.filters || 'Filtres'}</h3>
        </div>

        <form onSubmit={(e) => e.preventDefault()}>
          {/* Categories Section */}
          <div className='form-control categories-section'>
            <h5>{t.products.category || 'Catégories'}</h5>
            <div className='category-list'>
              {categories.map((item, index) => {
                const IconComponent = getCategoryIcon(item);
                const count = getCategoryCount(item);
                const isActive = category === item || category.toLowerCase() === item.toLowerCase();
                return (
                  <button
                    key={index}
                    type='button'
                    name='category'
                    data-category={item}
                    className={`category-item ${isActive ? 'active' : ''}`}
                    onClick={updateFilters}
                  >
                    <span className='category-icon-wrapper'>
                      <IconComponent className='category-icon' />
                    </span>
                    <span className='category-name'>
                      {item === 'all' ? (t.products?.all || 'Tous') : item}
                    </span>
                    <span className='category-count'>{count}</span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Colors Section */}
          <div className='form-control colors-section'>
            <h5>{t.products.colors || 'Couleurs'}</h5>
            <div className='colors'>
              {colors.map((item, index) => {
                if (item === 'all') {
                  return (
                    <button
                      key={index}
                      name='color'
                      data-color='all'
                      className={`color-btn all-color ${color === 'all' ? 'active' : ''}`}
                      onClick={updateFilters}
                      title={t.products?.all || 'All'}
                    />
                  );
                }

                return (
                  <button
                    key={index}
                    name='color'
                    data-color={item}
                    style={{ background: item }}
                    className={`color-btn ${color === item ? 'active' : ''}`}
                    onClick={updateFilters}
                    title={item}
                  >
                    {color === item && <FaCheck />}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Price Section */}
          <div className='form-control price-section'>
            <h5>{t.products.price || 'Prix'}</h5>
            <div className='price-slider-container'>
              <input
                type='range'
                name='price'
                id='price'
                min={min_price}
                max={max_price}
                value={price}
                onChange={updateFilters}
                className='price-slider'
              />
              <div className='price-labels'>
                <span className='price-label'>{formatPrice(min_price)}</span>
                <span className='price-label'>{formatPrice(price)}</span>
              </div>
            </div>
          </div>

          {/* Free Shipping */}
          <div className='form-control shipping-section'>
            <div className='shipping-box'>
              <input
                type='checkbox'
                name='shipping'
                id='shipping'
                checked={shipping}
                onChange={updateFilters}
              />
              <label htmlFor='shipping'>
                <span className='shipping-icon'>🚚</span>
                {t.services?.freeShipping || 'Livraison gratuite'}
              </label>
            </div>
          </div>
        </form>
      </div>
    </Wrapper>
  );
};

export default Filters;
